import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'booth',
    serviceName: 'shopadmin',
    query: gql`
      query booth($ids: [String]) {
        booth(ids: $ids) {
          data {
            code
            title
            is_active
            fee_value
            fee_ceiling
            shop {
              id
            }
            owner {
              id
            }
            fee_type {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateBooth',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateBooth(
        $ids: [String]!
        $title: String
        $code: String
        $shop_id: String
        $user_id: String
        $is_active: Int
        $fee_value: String
        $fee_type_id: String
        $fee_ceiling: String
      ) {
        updateBooth(
          ids: $ids
          title: $title
          code: $code
          shop_id: $shop_id
          user_id: $user_id
          is_active: $is_active
          fee_value: $fee_value
          fee_type_id: $fee_type_id
          fee_ceiling: $fee_ceiling
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
